'use client'

import {ChakraProvider, createSystem, defaultConfig, defineConfig} from '@chakra-ui/react'

const config = defineConfig({
    theme: {
        breakpoints: {
            xs: '200px'
        },
        tokens: {
            colors: {
                primary: {
                    DEFAULT: { value: "#bed6ed" },
                    50:  { value: "#f5fafe" },
                    100: { value: "#d4ebfa" },
                    200: { value: "#abd7f5" },
                    300: { value: "#82c3f0" },
                    400: { value: "#5badeb" },
                    500: { value: "#bed6ed" },
                    600: { value: "#9ab5c1" },
                    700: { value: "#7a94a0" },
                    800: { value: "#586f76" },
                    900: { value: "#32454b" },
                    950: { value: "#1a2225" },
                },
                secondary: {
                    DEFAULT: { value: "#222656" },
                    50:  { value: "#e8e8f5" },
                    100: { value: "#c0c0e1" },
                    200: { value: "#8a8abf" },
                    300: { value: "#54549d" },
                    400: { value: "#2b2b87" },
                    500: { value: "#222656" },
                    600: { value: "#1c1e4f" },
                    700: { value: "#16173f" },
                    800: { value: "#10102f" },
                    900: { value: "#080814" },
                    950: { value: "#04040a" },
                },
                third: {
                    DEFAULT: { value: "#f44c2a" },
                    50:  { value: "#ffece8" },
                    100: { value: "#ffd2c8" },
                    200: { value: "#ffad90" },
                    300: { value: "#ff7a56" },
                    400: { value: "#ff5430" },
                    500: { value: "#f44c2a" },
                    600: { value: "#cc3f22" },
                    700: { value: "#a7371b" },
                    800: { value: "#812a15" },
                    900: { value: "#531e0e" },
                    950: { value: "#2a1007" },
                },
                validation: {
                    default: { value: "#188F2C" }
                }
            }
        },
    },
})

const system = createSystem(defaultConfig, config)

export function Provider(props) {
  return (
    <ChakraProvider value={system}>
      {props.children}
    </ChakraProvider>
  )
}
